export default __webpack_public_path__ + "static/media/call-a-person-ind-flag.0641018e.svg";